import { DOCS_API_REFERENCE_ROUTE, DOCS_ROUTE } from "constants/links"
import { getFeatureSwitches } from "modules/featureswitch/FeatureSwitch"
import { SIDEBAR_ICON } from "./NavIcon"
import { type NavigationItemSchema } from "./Navigation"

const {
  METRICS_PAGE_ENABLED: isMetricsPageEnabled,
  MARKET_SECTORS_ENABLED: isMarketSectorsEnabled,
  TRENDING_CONTRACTS_ENABLED: isTrendingContractsEnabled,
  FINANCIAL_STATEMENTS_ENABLED: isFinancialStatementsEnabled,
  API_DOCS_ENABLED: isDocsEnabled,
  DATASET_FUNDRAISES_ENABLED: isFundraisesEnabled,
} = getFeatureSwitches()

export const navigationItems: NavigationItemSchema[] = [
  {
    title: "Home",
    href: "/",
    iconType: SIDEBAR_ICON.Home,
  },
  {
    title: "Discover",
    href: "/discover",
    iconType: SIDEBAR_ICON.Discover,
  },
  isMetricsPageEnabled && {
    title: "Metrics",
    href: "/metrics",
    iconType: SIDEBAR_ICON.Metrics,
  },
  isMarketSectorsEnabled && {
    title: "Market sectors",
    // NOTE: We probably should update route to match the title as well. Not necessarily best for the launch PR for history reasons among other things
    href: "/markets",
    iconType: SIDEBAR_ICON.Markets,
  },
  {
    title: "Projects",
    href: "/projects",
    iconType: SIDEBAR_ICON.Projects,
  },
  {
    title: "Datasets",
    href: "/datasets",
    iconType: SIDEBAR_ICON.Trending,
  },
].filter((obj): obj is NavigationItemSchema => !!obj)

export const navigationDocsItems: NavigationItemSchema[] = isDocsEnabled
  ? [
      {
        title: "API reference",
        href: DOCS_API_REFERENCE_ROUTE,
        iconType: SIDEBAR_ICON.ApiDocs,
      },
      {
        title: "Docs",
        href: DOCS_ROUTE,
        iconType: SIDEBAR_ICON.Docs,
      },
    ]
  : []
